export const SUGGESTION_SET_DATA = 'SUGGESTION_SET_DATA';
